import { useTranslation } from "next-i18next";
import Accordion from "../../components/v2/accordion/accordion";
import CallToActionBlog from "../../components/v2/blog/call-to-action-blog";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import SolutionFeatureSection from "../../components/v2/common/solution-feature";
import SolutionsHeroSection from "../../components/v2/common/solutions-hero";
import {
    CustomizeDataRetention, EnhanceSecurity,
    ImproveApplication,
    OptimizeInfra, ReduceDowntimeMTTR
} from "../../components/v2/icons";
import ClientTestimonials from "../../components/v2/mw-carousel/testimonial";
import TrustedCompanyTopHeading from "../../components/v2/mw-carousel/trust-company-heading-top";
import ProductResources from "../../components/v2/product/product-resource";
import '../../styles/scss/_faq-section.module.scss';

export default function DEM() {
    const { t } = useTranslation("common");
    const i18nData = t('solutions.dem', { returnObjects: true }) as any

    const resource = Array.isArray(i18nData?.resources) ? i18nData.resources : []

    const sectionsData = Array.isArray(i18nData?.sections) ? i18nData.sections : []

    const heroCardDetails = Array.isArray(i18nData?.hero?.cards) ? i18nData.hero.cards : []

    const faqs = Array.isArray(i18nData?.faq) ? i18nData.faq : i18nData?.faq

    return (
        <>

            <SolutionsHeroSection title={<h1><span className='text-gradient'>{i18nData?.hero?.titlePrefix}</span> {i18nData?.hero?.titleSuffix}</h1>} tag={i18nData?.hero?.tag} description={<p>{i18nData?.hero?.description}</p>} cardData={heroCardDetails} />

            <section className={"mw-card solutions-mw-card"}>
                <div className={"container"}>
                    <div className={"d-flex card-items"}>
                        <div className={"card-item"}>
                            <h2>
                                {i18nData?.sectionIntro?.title}
                            </h2>
                            <p>{i18nData?.sectionIntro?.description}</p>
                        </div>

                        {Array.isArray(i18nData?.introCards) && i18nData.introCards.length > 0 && (
                            <>
                                <CardWithIcon icon={<ImproveApplication/>} title={i18nData.introCards[0]?.title}
                                              description={i18nData.introCards[0]?.description}/>
                                {i18nData.introCards[1] && (
                                    <CardWithIcon icon={<OptimizeInfra/>} title={i18nData.introCards[1]?.title}
                                                  description={i18nData.introCards[1]?.description}/>
                                )}
                                {i18nData.introCards[2] && (
                                    <CardWithIcon icon={<CustomizeDataRetention/>} title={i18nData.introCards[2]?.title}
                                                  description={i18nData.introCards[2]?.description}/>
                                )}
                                {i18nData.introCards[3] && (
                                    <CardWithIcon icon={<EnhanceSecurity/>} title={i18nData.introCards[3]?.title}
                                                  description={i18nData.introCards[3]?.description}/>
                                )}
                                {i18nData.introCards[4] && (
                                    <CardWithIcon icon={<ReduceDowntimeMTTR/>} title={i18nData.introCards[4]?.title}
                                                  description={i18nData.introCards[4]?.description}/>
                                )}
                            </>
                        )}

                    </div>
                </div>
            </section>

            <TrustedCompanyTopHeading/>

            <CallToActionBlog title={t('solutions.common.optimizeInteractionsTitle')} isSignupBtn={true} isButton={true} />

            <section className={"user-monitor solutions_page"} id={'know-more'}>
                <div className={"container"}>

                    {sectionsData.map((section, index) => (
                        <SolutionFeatureSection
                            image={section.image}
                            imageAlt={section.imageAlt}
                            title={section.title}
                            list={section.list}
                            category={section.category}
                        />
                    ))}

                </div>
            </section>

            <ClientTestimonials />

            <ProductResources resources={resource}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{i18nData?.faqTitle || t('product.shared.faq.title')}</h2>
                    <p>{i18nData?.faqSubtitle || t('product.shared.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}